import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class TaxaJurosEquivalente extends BaseEntity {
    public indexador: number;
    public taxaJurosEquivalente: number;
    public dataInicioValidade: Date;
    public modoEdicao?: boolean;
    public indexadorOriginal: number;
    public taxaJurosEquivalenteOriginal: number;
    public dataInicioValidadeOriginal: Date;
}